export default __webpack_public_path__ + "static/media/ic_text-align-right.ea45ea14.svg";